import R from "ramda";

export const isEmptyObject = (obj) => !Object.keys(obj).length;

export const noop = () => {};

const omitProps = (froms, to) => R.pipe(R.omit(froms), R.objOf(to));
const resetProp = (from, to) => (data) => {
  if (typeof from === "function") {
    return from(data, to);
  }
  return {
    [to]: data[from],
  };
};

export const debug = R.curry(function(tag = "debug:", x) {
  console.log(tag, x);
  return x;
});

export const tranformTreeShape = (data) => {
  const setLabel = resetProp("title", "label");
  const setValue = resetProp("id", "value");
  const setChildren = R.pipe(
    R.prop("children"),
    R.ifElse(
      R.either(R.isNil, R.isEmpty),
      R.empty,
      R.pipe(R.map(tranformTreeShape), R.objOf("children"))
    )
  );

  return R.converge(R.unapply(R.mergeAll), [setLabel, setValue, setChildren])(
    data
  );
};

/**
 *
 * @param {String} label
 * @param {String} value
 */
export const tranformOptionsShape = (label: string | Function, value: string) =>
  R.pipe(
    R.defaultTo([]),
    R.map(
      R.converge(R.unapply(R.mergeAll), [
        resetProp(value, "value"),
        resetProp(label, "label"),
        R.objOf("rest"),
      ])
    )
  );

export const getCombineMapper = (v) => (fn) => fn(v);

export const getDeleteFunction = (fetchFn, effectCb) => {
  return R.pipe(R.prop("id"), R.of, fetchFn, R.andThen(effectCb));
};

export const stopPropagation = (e) => {
  e.stopPropagation();
};

export const getRenameKeysFunction = (keysMap) => (obj) =>
  Object.entries(obj).reduce(
    (a, [k, v]) =>
      k in keysMap ? { ...a, [keysMap[k]]: v } : { ...a, [k]: v },
    {}
  );

export const transferStaticToFunc = (fn) => {
  if (typeof fn === "function") return fn;
  return () => fn;
};

/**
 * 把parentID格式的treedata转换成children格式的treedata,并且resetFields
 */
export const unFlatTreeData = (key = "id", pid = "parentId", rootId = 0) => {
  return function _parseFunc(tree, merge = {}) {
    const root = [];
    tree.reduce((dict, node) => {
      if (!dict[node[key]]) {
        dict[node[key]] = {
          // ...merge,
        };
      }
      let _merge = merge;
      if (typeof merge === "function") {
        _merge = merge(node);
      }

      Object.assign(dict[node[key]], node, _merge);

      if (node[pid] == rootId) {
        root.push(dict[node[key]]);
      } else if (!dict[node[pid]]) {
        dict[node[pid]] = {
          // ...merge,
          children: [dict[node[key]]],
        };
      } else {
        dict[node[pid]].children || (dict[node[pid]].children = []);
        dict[node[pid]].children.push(dict[node[key]]);
      }
      return dict;
    }, {});
    return root;
  };
};
